/* eslint-disable global-require */
import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import axios from 'axios';
import {
  GRUNTWORX_INTEGRATION_STATUS,
  GRUNTWORX_CONNECTION,
  DISCONNECT_GRUNTWORX,
} from 'constants/constants';
import ConfirmationModal from 'common/ConfirmationModal';
import { AlertMessage } from 'utilities/utils';

const initialData = {
  gruntworxKey: '',
  loading: true,
  gruntworxData: {},
  apiKeyModal: false,
  apiKeySaveModal: false,
  testingConnection: false,
  errors: {} as { gruntworxKey?: string },
};

export const GruntworxSettings = () => {
  const [data, setData] = useState(initialData);

  const gruntworxIntegrationStatus = async () => {
    try {
      const response = await axios
        .get(GRUNTWORX_INTEGRATION_STATUS)
        .then((res) => res.data);
      setData({ ...data, loading: false, gruntworxData: response });
    } catch (err) {
      setData({ ...data, loading: false });
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.loading) {
      gruntworxIntegrationStatus();
    }
  }, []);

  const handleValidation = () => {
    const err: { gruntworxKey?: string } = {};
    let isValid = true;
    if (!data.gruntworxKey) {
      isValid = false;
      err.gruntworxKey = 'Enter GruntWorx API key';
    }
    setData({ ...data, errors: err });
    return isValid;
  };

  const handleChange = (e: any, connect = '') => {
    if (e === 'apiKeyModal') {
      if (connect === 'connect') {
        // Just open the modal for entering API key
        setData({
          ...data,
          apiKeyModal: true,
          gruntworxKey: '',
          errors: {},
        });
      } else if (connect === 'apiKeySaved') {
        // Validate and submit API key
        const validate = handleValidation();
        if (validate) {
          setData({ ...data, loading: true });
          const gruntworxdata = {
            gruntworx_key: data.gruntworxKey,
          };
          axios.post(GRUNTWORX_CONNECTION, gruntworxdata)
            .then((response) => {
              const res = response.data;
              if (res.success) {
                setData({
                  ...data,
                  gruntworxData: res,
                  loading: false,
                  apiKeyModal: false,
                  gruntworxKey: '',
                  errors: {},
                });
                AlertMessage('success', 'GruntWorx connected successfully!', 3000);
              } else {
                const err: any = {};
                err.gruntworxKey = res.message;
                setData({ ...data, errors: err, loading: false });
              }
            })
            .catch((error) => {
              const err: any = {};
              err.gruntworxKey = 'Connection failed. Please check your credentials.';
              setData({ ...data, errors: err, loading: false });
              console.log(error);
            });
        }
      } else {
        // Close the modal
        setData({
          ...data,
          apiKeyModal: false,
          gruntworxKey: '',
          errors: {},
        });
      }
    } else if (e.target) {
      // Handle input change
      setData({ ...data, [e.target.name]: e.target.value, errors: {} });
    }
  };

  const handleDisconnect = async () => {
    try {
      const url = DISCONNECT_GRUNTWORX;
      await axios.delete(url).then((res) => res.data);
      setData({
        ...data,
        loading: false,
        gruntworxKey: '',
        apiKeySaveModal: false,
        gruntworxData: { message: 'You are not connected to GruntWorx' },
      });
      AlertMessage('success', 'GruntWorx disconnected successfully', 3000);
    } catch (err) {
      setData({ ...data, loading: false });
      console.log(err);
    }
  };

  const gruntworxIntData = data.gruntworxData as any;
  const gruntworxIntegrationData = gruntworxIntData.data;

  return (
    <div className="col-lg-4 col-sm-12 col-md-6">
      {data.loading ? <div id="loading" /> : null}
      <div
        className="card mb-4 shadow-s"
        style={{ height: 'calc(100% - 16px)' }}
      >
        <div
          className="card-img-top d-flex justify-content-center"
          style={{ height: '150px', alignItems: 'center' }}
        >
          <img
            src={require('images/gruntworx.png')}
            alt="GruntWorx Logo"
            style={{ maxWidth: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
        <div className="card-body">
          <h5 className="card-title">GruntWorx Integration</h5>
          <div className="h-100">
            {gruntworxIntData.message === 'You are not connected to GruntWorx' &&
            !gruntworxIntegrationData ? (
              <div className="d-flex h-100 flex-column justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary mb-5"
                  onClick={() => handleChange('apiKeyModal', 'connect')}
                >
                  Connect
                </button>
              </div>
            ) : null}
            {gruntworxIntegrationData &&
            gruntworxIntegrationData.status === 'New' &&
            gruntworxIntData.logged_in_user_email &&
            gruntworxIntData.logged_in_user_email ===
              gruntworxIntegrationData.created_by ? (
              <div className="d-flex h-100 flex-column justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => handleChange('apiKeyModal', '')}
                >
                  Continue Setup
                </button>
                <button
                  type="button"
                  className="btn btn-primary mb-5"
                  onClick={() => setData({ ...data, apiKeySaveModal: true })}
                >
                  Abandon Setup
                </button>
              </div>
            ) : null}
            {gruntworxIntegrationData &&
            gruntworxIntegrationData.status === 'New' &&
            gruntworxIntData.logged_in_user_email &&
            gruntworxIntData.logged_in_user_email !==
              gruntworxIntegrationData.created_by ? (
              <div className="d-flex h-100 flex-column justify-content-end">
                <button type="button" className="btn btn-primary mt-3" disabled>
                  Setup in Progress
                </button>
                {gruntworxIntegrationData.created_by && (
                  <p className="text-info mt-2">
                    Initiated by {gruntworxIntegrationData.created_by}
                  </p>
                )}
              </div>
            ) : null}
            {gruntworxIntegrationData &&
            gruntworxIntegrationData.status === 'Active' ? (
              <div className="d-flex h-100 flex-column justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary mb-5"
                  onClick={() => setData({ ...data, apiKeySaveModal: true })}
                >
                  Disconnect
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {data.apiKeyModal ? (
        <Modal
          isOpen
          className="customModal customModal--center customModal--alert customModal--w500 customModal--nopadding"
        >
          <ModalHeader className="ModalHeader">
            <button
              name="apiKeyModal"
              type="button"
              className="close"
              aria-label="Close"
              onClick={() => handleChange('apiKeyModal', '')}
            >
              <i className="icon-close2" aria-hidden="true" />
            </button>
          </ModalHeader>
          <ModalBody className="modalContent">
            <div className="modalContent--inner">
              <div className="frmMxWidth">
                <div className="row">
                  <div className="col-12">
                    <div className="d-block">
                      <h3 className="fontSize text-center">
                        Please enter your GruntWorx API credentials
                      </h3>
                      <div
                        className={`form-group${
                          data.errors.gruntworxKey ? ' form-error' : ''
                        }`}
                      >
                        <label className="form-label">API Key</label>
                        <div className="labelValue">
                          <input
                            type="password"
                            name="gruntworxKey"
                            id="gruntworxKey"
                            className="form-control"
                            onChange={(e) => handleChange(e, '')}
                            autoComplete="off"
                            value={data.gruntworxKey}
                            placeholder="Enter your GruntWorx API key (format: api_key:secret_key)"
                          />
                        </div>
                        {data.errors.gruntworxKey ? (
                          <div className="labelValue">
                            <span className="error_label">
                              {data.errors.gruntworxKey}
                            </span>
                          </div>
                        ) : null}
                        <div className="labelValue">
                          <small className="form-text text-muted">
                            Enter your GruntWorx API key
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 justify-content-end formbtn justify-content-end mt-0">
                    <div className="btn-wrap d-flex btn--leftspace">
                      <button
                        type="button"
                        className="btn btn-sm w-50 btn-primary"
                        onClick={() =>
                          handleChange('apiKeyModal', 'apiKeySaved')
                        }
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm w-50 btn-outline-light"
                        onClick={() => handleChange('apiKeyModal', '')}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      ) : null}
      <ConfirmationModal
        isOpen={data.apiKeySaveModal}
        isHtml
        messageText={
          "<div><h5>Remove access?</h5><p>Liscio will no longer have access to your GruntWorx Account. You'll need to grant access if you want to use this app or service again.</p></div>"
        }
        noBtnClick={() => setData({ ...data, apiKeySaveModal: false })}
        yesBtnClick={handleDisconnect}
        yesBtnText="Ok"
        noBtnText="Cancel"
        btnClassName="justify-content-start"
      />
    </div>
  );
}; 